import classNames from "classnames";
import Image from "next/image";
import Link from "next/link";
import { isValidElement } from "react";
import { createImageSizes } from "../../utils/image";
import Impression from "./Impression";

export const ODDS_ADVERTISEMENT_PROVIDER = {
  PAF: "paf",
  SPEEDY_BET: "speedybet",
  X3000: "x3000",
  SNABBARE: "snabbare",
  COMEON: "comeon",
};

export const ODDS_ADDVERTISEMENT_IMPRESSION = {
  TRANSFERS:
    '<IMG SRC="https://ad.doubleclick.net/ddm/trackimp/N1212566.675342FOTBOLLTRANSFERS./B33044905.414046747;dc_trk_aid=606356894;dc_trk_cid=229638809;ord=[timestamp];dc_lat=;dc_rdid=;tag_for_child_directed_treatment=;tfua=;gdpr=${GDPR};gdpr_consent=${GDPR_CONSENT_755};ltd=;dc_tdv=1?" attributionsrc BORDER="0" HEIGHT="1" WIDTH="1" ALT="Advertisement">',
  TRANSFERS_SECONDARY:
    '<IMG SRC="https://ad.doubleclick.net/ddm/trackimp/N1212566.675342FOTBOLLTRANSFERS./B33209313.414153781;dc_trk_aid=606599224;dc_trk_cid=230245992;ord=[timestamp];dc_lat=;dc_rdid=;tag_for_child_directed_treatment=;tfua=;gdpr=${GDPR};gdpr_consent=${GDPR_CONSENT_755};ltd=;dc_tdv=1?" attributionsrc BORDER="0" HEIGHT="1" WIDTH="1" ALT="Advertisement">',
};

export const ODDS_ADVERTISEMENT_URL = {
  START:
    "https://ad.doubleclick.net/ddm/trackclk/N1212566.675342FOTBOLLTRANSFERS./B33044905.414046747;dc_trk_aid=606356894;dc_trk_cid=229638809;dc_lat=;dc_rdid=;tag_for_child_directed_treatment=;tfua=;gdpr=${GDPR};gdpr_consent=${GDPR_CONSENT_755};ltd=;dc_tdv=1",
  START_SECONDARY:
    "https://ad.doubleclick.net/ddm/trackclk/N1212566.675342FOTBOLLTRANSFERS./B33209313.414153781;dc_trk_aid=606599224;dc_trk_cid=230245992;dc_lat=;dc_rdid=;tag_for_child_directed_treatment=;tfua=;gdpr=${GDPR};gdpr_consent=${GDPR_CONSENT_755};ltd=;dc_tdv=1",
  LEAGUES:
    "https://ad.doubleclick.net/ddm/trackclk/N1212566.675342FOTBOLLTRANSFERS./B33044905.414046747;dc_trk_aid=606356894;dc_trk_cid=229638809;dc_lat=;dc_rdid=;tag_for_child_directed_treatment=;tfua=;gdpr=${GDPR};gdpr_consent=${GDPR_CONSENT_755};ltd=;dc_tdv=1",
  CLUBS:
    "https://ad.doubleclick.net/ddm/trackclk/N1212566.675342FOTBOLLTRANSFERS./B33044905.414046747;dc_trk_aid=606356894;dc_trk_cid=229638809;dc_lat=;dc_rdid=;tag_for_child_directed_treatment=;tfua=;gdpr=${GDPR};gdpr_consent=${GDPR_CONSENT_755};ltd=;dc_tdv=1",
  CLUBS_TOP:
    "https://ad.doubleclick.net/ddm/trackclk/N1212566.675342FOTBOLLTRANSFERS./B33044905.414046747;dc_trk_aid=606356894;dc_trk_cid=229638809;dc_lat=;dc_rdid=;tag_for_child_directed_treatment=;tfua=;gdpr=${GDPR};gdpr_consent=${GDPR_CONSENT_755};ltd=;dc_tdv=1",
  CLUBS_TOP_SECONDARY:
    "https://ad.doubleclick.net/ddm/trackclk/N1212566.675342FOTBOLLTRANSFERS./B33209313.414153781;dc_trk_aid=606599224;dc_trk_cid=230245992;dc_lat=;dc_rdid=;tag_for_child_directed_treatment=;tfua=;gdpr=${GDPR};gdpr_consent=${GDPR_CONSENT_755};ltd=;dc_tdv=1",
  PLAYERS:
    "https://ad.doubleclick.net/ddm/trackclk/N1212566.675342FOTBOLLTRANSFERS./B33044905.414046747;dc_trk_aid=606356894;dc_trk_cid=229638809;dc_lat=;dc_rdid=;tag_for_child_directed_treatment=;tfua=;gdpr=${GDPR};gdpr_consent=${GDPR_CONSENT_755};ltd=;dc_tdv=1",
  PLAYERS_SECONDARY:
    "https://ad.doubleclick.net/ddm/trackclk/N1212566.675342FOTBOLLTRANSFERS./B33209313.414153781;dc_trk_aid=606599224;dc_trk_cid=230245992;dc_lat=;dc_rdid=;tag_for_child_directed_treatment=;tfua=;gdpr=${GDPR};gdpr_consent=${GDPR_CONSENT_755};ltd=;dc_tdv=1",
  NEWS: "https://ad.doubleclick.net/ddm/trackclk/N1212566.675342FOTBOLLTRANSFERS./B33044905.414046747;dc_trk_aid=606356894;dc_trk_cid=229638809;dc_lat=;dc_rdid=;tag_for_child_directed_treatment=;tfua=;gdpr=${GDPR};gdpr_consent=${GDPR_CONSENT_755};ltd=;dc_tdv=1",
  NEWS_SECONDARY:
    "https://ad.doubleclick.net/ddm/trackclk/N1212566.675342FOTBOLLTRANSFERS./B33209313.414316607;dc_trk_aid=606567990;dc_trk_cid=229718621;dc_lat=;dc_rdid=;tag_for_child_directed_treatment=;tfua=;gdpr=${GDPR};gdpr_consent=${GDPR_CONSENT_755};ltd=;dc_tdv=1",
  TRANSFERS:
    "https://ad.doubleclick.net/ddm/trackclk/N1212566.675342FOTBOLLTRANSFERS./B33044905.414046747;dc_trk_aid=606356894;dc_trk_cid=229638809;dc_lat=;dc_rdid=;tag_for_child_directed_treatment=;tfua=;gdpr=${GDPR};gdpr_consent=${GDPR_CONSENT_755};ltd=;dc_tdv=1",
  TRANSFERS_SECONDARY:
    "https://ad.doubleclick.net/ddm/trackclk/N1212566.675342FOTBOLLTRANSFERS./B33209313.414153781;dc_trk_aid=606599224;dc_trk_cid=230245992;dc_lat=;dc_rdid=;tag_for_child_directed_treatment=;tfua=;gdpr=${GDPR};gdpr_consent=${GDPR_CONSENT_755};ltd=;dc_tdv=1",
  NEWS_ODDS_LIST:
    "https://ad.doubleclick.net/ddm/trackclk/N1212566.675342FOTBOLLTRANSFERS./B33044905.414046747;dc_trk_aid=606356894;dc_trk_cid=229638809;dc_lat=;dc_rdid=;tag_for_child_directed_treatment=;tfua=;gdpr=${GDPR};gdpr_consent=${GDPR_CONSENT_755};ltd=;dc_tdv=1",
};

type OddsAdvertisementProps = {
  provider?: string;
  image?: string;
  url: string;
  text?: string | JSX.Element;
  reversed?: boolean;
  showDisclaimer?: boolean;
  bottomText?: string;
  boldBottomText?: boolean;
  largeBottomText?: boolean;
  impression?: string;
};

const getImageUrl = (provider: string) => {
  switch (provider) {
    case "paf":
      return "/images/paf-liveodds.png";
    case "speedybet":
      return "/images/speedybet.png";
    case "x3000":
      return "/images/x3000.png";
    case "snabbare":
      return "/images/snabbare.svg";
    case "comeon":
      return "/images/comeon.svg";
    default:
      return "";
  }
};

const OddsAdvertisement = (props: OddsAdvertisementProps) => {
  return (
    <Impression impression={props.impression}>
      <div data-nosnippet>
        <Link passHref href={props.url}>
          <a
            rel="nofollow sponsored"
            target="_blank"
            className={classNames("flex items-center", {
              "flex-row-reverse": props.reversed,
            })}
          >
            {(props.provider || props.image) && (
              <div className="relative h-[34px] md:h-[40px] w-[80px] flex-shrink-0">
                <Image
                  unoptimized
                  layout="fill"
                  src={
                    props.provider
                      ? getImageUrl(props.provider)
                      : `${process.env.NEXT_PUBLIC_ASSET_SERVER_URL}${props.image}`
                  }
                  alt=""
                  className="object-contain"
                  sizes={createImageSizes({
                    mobile: "15vw",
                    tablet: "15vw",
                    desktop: "15vw",
                  })}
                />

                {props.showDisclaimer && (
                  <span className="text-[10px] absolute -bottom-4 inset-x-0 text-center whitespace-nowrap">
                    18+ Stödlinjen.se
                  </span>
                )}
                {props.bottomText && !props.showDisclaimer && (
                  <span
                    className={classNames(
                      "text-[10px] absolute -bottom-4 inset-x-0 text-center",
                      {
                        "font-bold": props.boldBottomText,
                        "text-[12px] -bottom-5": props.largeBottomText,
                      }
                    )}
                  >
                    {props.bottomText}
                  </span>
                )}
              </div>
            )}

            {props.text && typeof props.text === "string" && (
              <span className="mx-2 font-bold">{props.text}</span>
            )}

            {props.text && isValidElement(props.text) && props.text}
          </a>
        </Link>
      </div>
    </Impression>
  );
};

export default OddsAdvertisement;
